import { render } from "./accountFooter.vue?vue&type=template&id=b010054e&scoped=true"
import script from "./accountFooter.vue?vue&type=script&lang=js"
export * from "./accountFooter.vue?vue&type=script&lang=js"

import "./accountFooter.vue?vue&type=style&index=0&id=b010054e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b010054e"

export default script